<p>add-counselors works!</p>
